import { useContext } from 'react'
import { Stack } from '@mui/material'
import { RecentUserItem } from '$common/recent-user-item'
import { useRecentUsers } from '$logic/room-list/room-list-search.react-hook'
import { SelectionMapContext } from '$comp/_app/components/leftPanel/components/forward-list'

export function RecentUsers({
  hasSelection,
  onSelectedChange,
  onSelect,
}: {
  hasSelection: boolean
  onSelectedChange: (selected: boolean, chatId: string) => unknown
  onSelect: (selectedRoomId: string) => unknown
}) {
  const recentUsers = useRecentUsers()

  const selectionMap = useContext(SelectionMapContext)

  return (
    <Stack direction="row" sx={{ overflow: 'auto', backgroundColor: 'white' }}>
      {recentUsers.map(({ userId, roomId }) => (
        <RecentUserItem
          key={userId}
          userId={userId}
          selected={selectionMap[roomId]}
          onSelectedChange={v => onSelectedChange(v, roomId)}
          hasSelection={hasSelection}
          onSelect={() => onSelect(roomId)}
        />
      ))}
    </Stack>
  )
}
